function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRoobrickLogoV4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "122.279 99.034 258.818 258.818",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern-0",
    x: 0,
    y: 0,
    width: 25,
    height: 25,
    patternUnits: "userSpaceOnUse",
    viewBox: "0 0 100 100"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 50,
    height: 100,
    style: {
      fill: "black"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fillOpacity: 0.85,
      fill: "rgb(13, 123, 223)"
    },
    d: "M 152.279 99.034 H 247.688 V 194.443 A 30 30 0 0 1 217.688 224.443 H 122.279 V 129.034 A 30 30 0 0 1 152.279 99.034 Z",
    bxShape: "rect 122.279 99.034 125.409 125.409 30 0 30 0 1@3ada73bd"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "rgb(7, 109, 212)"
    },
    d: "M 255.688 99.034 H 351.097 A 30 30 0 0 1 381.097 129.034 V 224.443 H 285.688 A 30 30 0 0 1 255.688 194.443 V 99.034 Z",
    bxShape: "rect 255.688 99.034 125.409 125.409 0 30 0 30 1@88b38b76"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillOpacity: 0.55,
      fill: "rgb(28, 137, 235)"
    },
    d: "M 285.688 232.443 H 381.097 V 327.852 A 30 30 0 0 1 351.097 357.852 H 255.688 V 262.443 A 30 30 0 0 1 285.688 232.443 Z",
    bxShape: "rect 255.688 232.443 125.409 125.409 30 0 30 0 1@4f9744ab"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillOpacity: 0.7,
      fill: "rgb(40, 148, 244)"
    },
    d: "M 122.279 232.443 H 217.688 A 30 30 0 0 1 247.688 262.443 V 357.852 H 152.279 A 30 30 0 0 1 122.279 327.852 V 232.443 Z",
    bxShape: "rect 122.279 232.443 125.409 125.409 0 30 0 30 1@e3c75ab8"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoobrickLogoV4);
export default __webpack_public_path__ + "static/media/roobrick-logo-v4.1992cae9f4559f09f3648be2a4fc62ca.svg";
export { ForwardRef as ReactComponent };